var redirect_constants = {
   "/?mode=f5": "/blogs/library/htc_tablesize",
   "/?mode=f11": "/blogs/our-brand/kanademono-philosophy-1",
   "/?mode=f12": "/blogs/our-brand/kanademono-philosophy-2",
   "/?mode=f3": "/blogs/library/htc_wood",
   "/?mode=f25": "/blogs/library/legs",
   "/?mode=f22": "/pages/for-business",
   "/?mode=f18": "/blogs/library/productdetail",
   "/?mode=f30": "/blogs/our-brand/about-paint",
   "/?mode=f31": "/blogs/our-brand/about-wood",
   "/?mode=f27": "/blogs/our-brand/about-maintainance",
   "/?mode=f41": "/blogs/library/assembling",
   "/?mode=f43": "/blogs/library/furniture-linoleum",
   "/?mode=f36": "/blogs/library/chair",
   "/?mode=f44": "/blogs/library/carrying",
   "/?mode=cate&cbid=2368157&csid=0": "/collections/table-desk",
   "/?mode=cate&cbid=2368157&csid=1": "/collections/sugi",
   "/?mode=cate&cbid=2368157&csid=2": "/collections/pine",
   "/?mode=cate&cbid=2368157&csid=3": "/collections/reclaimed-wood",
   "/?mode=cate&cbid=2368157&csid=5": "/collections/rubberwood",
   "/?mode=cate&cbid=2368157&csid=7": "/collections/whiteash",
   "/?mode=cate&cbid=2368157&csid=9": "/collections/linoleum",
   "/?mode=cate&cbid=2368157&csid=6": "/collections/for-office",
   "/?mode=cate&cbid=2368157&csid=8": "/collections/standing-desk",
   "/?mode=cate&cbid=2487721&csid=1": "/collections/hida-karamatsu",
   "/?mode=cate&cbid=2487721&csid=2": "/collections/nagara-sugi",
   "/?mode=cate&cbid=2487721&csid=3": "/collections/gifu-hinoki",
   "/?mode=cate&cbid=2527711&csid=0": "/collections/cafe-table",
   "/?mode=cate&cbid=2529357&csid=0": "/collections/low-table",
   "/?mode=cate&cbid=2442963&csid=0": "/collections/table-legs",
   "/?mode=cate&cbid=2442963&csid=1": "/collections/standard",
   "/?mode=cate&cbid=2442963&csid=2": "/collections/order-legs",
   "/?mode=cate&cbid=2562237&csid=0": "/collections/tv-board",
   "/?mode=cate&cbid=2581417&csid=0": "/collections/shelf",
   "/?mode=cate&cbid=2560043&csid=1": "/collections/table-top",
   "/?mode=cate&cbid=2446370&csid=0": "/collections/chair",
   "/?mode=cate&cbid=2446370&csid=1": "/collections/dining-chair",
   "/?mode=cate&cbid=2446370&csid=2": "/collections/desk-chair",
   "/?mode=cate&cbid=2446370&csid=3": "/collections/bench",
   "/?mode=cate&cbid=2446370&csid=4": "/collections/stool",
   "/?mode=cate&cbid=2446370&csid=5": "/collections/sofa",
   "/?mode=cate&cbid=2465212&csid=0": "/collections/lighting",
   "/?mode=cate&cbid=2465212&csid=1": "/collections/pendant-light",
   "/?mode=cate&cbid=2465212&csid=2": "/collections/floor-light",
   "/?mode=cate&cbid=2465212&csid=3": "/collections/desk-light",
   "/?mode=cate&cbid=2500341&csid=1": "/collections/rack",
   "/?mode=cate&cbid=2500341&csid=2": "/collections/mirror",
   "/?mode=cate&cbid=2500341&csid=7": "/collections/rack",
   "/?mode=cate&cbid=2558683&csid=0": "/collections/office",
   "/?mode=cate&cbid=2510683&csid=0": "/collections/rug",
   "/?mode=cate&cbid=2510684&csid=0": "/collections/curtain",
   "/?mode=cate&cbid=2510684&csid=1": "/collections/outer-curtain",
   "/?mode=cate&cbid=2510684&csid=2": "/collections/lace-curtain",
   "/?mode=cate&cbid=2510684&csid=3": "/collections/tassel",
   "/?mode=cate&cbid=2512802&csid=0": "/collections/art",
   "/?mode=cate&cbid=2494745&csid=0": "/collections/boutique",
   "/?mode=cate&cbid=2494745&csid=1": "/collections/boutique-table",
   "/?mode=cate&cbid=2494745&csid=2": "/collections/boutique-chair",
   "/?mode=cate&cbid=2494745&csid=3": "/collections/boutique-lighting",
   "/?mode=cate&cbid=2573263&csid=0": "/collections/green",
   "/?mode=cate&cbid=2555611&csid=0": "/collections/selection",
   "/?mode=grp&gid=1877390": "/collections/steel-leg",
   "/?mode=grp&gid=1877393": "/collections/stainless-leg",
   "/?pid=125839709": "/products/tbl-k01-bk",
   "/?pid=133756972": "/products/tbl-k02-bk",
   "/?pid=133772676": "/products/tbl-k03-bk",
   "/?pid=133773619": "/products/tbl-k04-bk",
   "/?pid=146053585": "/products/tbl-k05-bk",
   "/?pid=147379489": "/products/tbl-k01-wh",
   "/?pid=151091949": "/products/spl-k04-sug-d",
   "/?pid=125840720": "/products/tbl-k04-bk",
   "/?pid=134092490": "/products/tbl-k04-bk",
   "/?pid=134092750": "/products/tbl-k04-bk",
   "/?pid=134092984": "/products/tbl-k04-bk",
   "/?pid=146097684": "/products/tbl-k04-bk",
   "/?pid=147379496": "/products/tbl-k04-kwh",
   "/?pid=126094372": "/products/tbl-k02-bk",
   "/?pid=134090916": "/products/tbl-k03-bk",
   "/?pid=134091146": "/products/tbl-k04-bk",
   "/?pid=134091593": "/products/tbl-k05-bk",
   "/?pid=146053909": "/products/tbl-k06-bk",
   "/?pid=145928470": "/products/tbl-k02-kwh",
   "/?pid=149429439": "/products/tbl-k03-bk",
   "/?pid=149429650": "/products/tbl-k04-bk",
   "/?pid=132939749": "/products/tbl-k05-bk",
   "/?pid=140428392": "/products/tbl-k06-bk",
   "/?pid=141036214": "/products/tbl-k07-bk",
   "/?pid=141036273": "/products/tbl-k08-bk",
   "/?pid=142870603": "/products/tbl-k09-bk",
   "/?pid=146097687": "/products/tbl-k10-bk",
   "/?pid=148541904": "/products/tbl-k10-bk",
   "/?pid=148541954": "/products/tbl-k10-bk",
   "/?pid=145928500": "/products/tbl-k11-bk",
   "/?pid=146368788": "/products/tbl-k12-bk",
   "/?pid=146368805": "/products/tbl-k13-bk",
   "/?pid=146368848": "/products/tbl-k14-bk",
   "/?pid=146368880": "/products/tbl-k15-bk",
   "/?pid=146368921": "/products/tbl-k16-bk",
   "/?pid=145928502": "/products/tbl-k12-bk",
   "/?pid=146368794": "/products/tbl-k13-bk",
   "/?pid=146368808": "/products/tbl-k14-bk",
   "/?pid=146368853": "/products/tbl-k15-bk",
   "/?pid=146368905": "/products/tbl-k16-bk",
   "/?pid=146368923": "/products/tbl-k17-bk",
   "/?pid=145928496": "/products/tbl-k03-kwh",
   "/?pid=145928486": "/products/tbl-k03-kwh",
   "/?pid=146566300": "/products/tbl-k03-trp-bk",
   "/?pid=151137585": "/products/spl-k01-rub-na",
   "/?pid=151137645": "/products/spl-k01-rub-tb",
   "/?pid=151137654": "/products/spl-k01-rub-bk",
   "/?pid=147087901": "/products/tbl-k08-bk",
   "/?pid=147087919": "/products/tbl-k08-bk",
   "/?pid=147087932": "/products/tbl-k08-bk",
   "/?pid=147087936": "/products/tbl-k08-bk",
   "/?pid=147087939": "/products/tbl-k08-bk",
   "/?pid=147291863": "/products/tbl-k08-kwh",
   "/?pid=150326742": "/products/tbl-k10-bk",
   "/?pid=150643979": "/products/tbl-k10-bk",
   "/?pid=150645372": "/products/tbl-k10-bk",
   "/?pid=150645389": "/products/tbl-k10-bk",
   "/?pid=151057036": "/products/tbl-k10-bk",
   "/?pid=150326900": "/products/tbl-k10-bk",
   "/?pid=149272582": "/products/dsk-k02-squ-bk",
   "/?pid=149347727": "/products/dsk-k06-squ-bk",
   "/?pid=149347775": "/products/dsk-k07-squ-bk",
   "/?pid=149270946": "/products/dsk-k02-squ-kwh",
   "/?pid=148563537": "/products/dsk-k03-squ-bk",
   "/?pid=149272612": "/products/dsk-k02-squ-bk",
   "/?pid=149347690": "/products/dsk-k06-squ-bk",
   "/?pid=149347705": "/products/dsk-k07-squ-bk",
   "/?pid=149402896": "/products/dsk-k02-squ-kwh",
   "/?pid=150699167": "/products/dsk-k02-squ-bk",
   "/?pid=150853002": "/products/dsk-k06-squ-bk",
   "/?pid=151056977": "/products/dsk-k07-squ-bk",
   "/?pid=150756240": "/products/dsk-k02-squ-kwh",
   "/?pid=148796815": "/products/dsk-k02-squ-bk",
   "/?pid=149014938": "/products/dsk-k06-squ-bk",
   "/?pid=149014939": "/products/dsk-k07-squ-bk",
   "/?pid=146135434": "/products/dsk-k04-sb-bk",
   "/?pid=149272654": "/products/kdt-157-ttb",
   "/?pid=149402532": "/products/dsk-k09-sb-bk",
   "/?pid=149402874": "/products/dsk-k04-sb-wh",
   "/?pid=148179388": "/products/dsk-k04-sb-bk",
   "/?pid=142828243": "/products/dsk-k05-squ-bk",
   "/?pid=150514345": "/products/dsk-k05-squ-bk",
   "/?pid=148208805": "/products/dsk-k05-squ-bk",
   "/?pid=147508763": "/products/dsk-k01-na",
   "/?pid=149214089": "/products/dsk-k01-tb",
   "/?pid=149828384": "/products/dsk-k01-bb",
   "/?pid=149214081": "/products/dsk-k10",
   "/?pid=132940897": "/products/tbl-k05-bk",
   "/?pid=139035864": "/products/tbl-k05-bk",
   "/?pid=139035888": "/products/tbl-k05-bk",
   "/?pid=139035946": "/products/tbl-k05-bk",
   "/?pid=146097851": "/products/tbl-k05-bk",
   "/?pid=147379523": "/products/tbl-k05-kwh",
   "/?pid=132941059": "/products/tbl-k06-bk",
   "/?pid=139035566": "/products/tbl-k07-bk",
   "/?pid=139035594": "/products/tbl-k08-bk",
   "/?pid=139035615": "/products/tbl-k09-bk",
   "/?pid=146098074": "/products/tbl-k10-bk",
   "/?pid=147379532": "/products/tbl-k06-kwh",
   "/?pid=132940596": "/products/tbl-k07-bk",
   "/?pid=139034799": "/products/tbl-k07-bk",
   "/?pid=139035189": "/products/tbl-k07-bk",
   "/?pid=139035270": "/products/tbl-k07-bk",
   "/?pid=146098078": "/products/tbl-k07-bk",
   "/?pid=147379537": "/products/tbl-k07-kwh",
   "/?pid=145583609": "/products/ctb-k04-4pin",
   "/?pid=147214271": "/products/ctb-k05-4pin",
   "/?pid=143669433": "/products/tt-rub-tb-cf",
   "/?pid=143904902": "/products/tt-rub-ct",
   "/?pid=145110605": "/products/tt-sug-ct",
   "/?pid=144972810": "/products/tt-rub-tb-cf",
   "/?pid=144976721": "/products/tt-rub-ct",
   "/?pid=145110604": "/products/tt-sug-ct",
   "/?pid=145130805": "/products/tt-rub-tb-cf",
   "/?pid=143906150": "/products/tt-rub-tb-cf",
   "/?pid=143921852": "/products/tt-rub-ct",
   "/?pid=144669300": "/products/ltb-k04-bk",
   "/?pid=146410534": "/products/ltb-k04-wh",
   "/?pid=144020760": "/products/ltb-k02-bk",
   "/?pid=144023020": "/products/ltb-k01-bk",
   "/?pid=144736989": "/products/ltb-k03-bk",
   "/?pid=147522244": "/products/ltb-101",
   "/?pid=133776642": "/products/squ-k11",
   "/?pid=149429403": "/products/sls-k11",
   "/?pid=133776344": "/products/x-k11",
   "/?pid=146045412": "/products/trp-k11",
   "/?pid=133776559": "/products/a-k11",
   "/?pid=133776501": "/products/i-k11",
   "/?pid=144004599": "/products/fp-k11",
   "/?pid=144005566": "/products/fp-k12",
   "/?pid=144007116": "/products/sb-011-bk",
   "/?pid=146135504": "/products/sb-011-wh",
   "/?pid=148684207": "/products/squ-012-wh",
   "/?pid=149238511": "/products/squ-k13",
   "/?pid=145130866": "/products/pin-k11-q3",
   "/?pid=145206892": "/products/pin-k11-q4",
   "/?pid=149429612": "/products/pin-k12",
   "/?pid=144683818": "/products/squ-011-bk",
   "/?pid=146410726": "/products/squ-011-wh",
   "/?pid=145335734": "/products/squ-010",
   "/?pid=145400798": "/products/x-010",
   "/?pid=145401576": "/products/trp-010",
   "/?pid=145458799": "/products/i-010",
   "/?pid=145787465": "/products/squ-k12",
   "/?pid=146473198": "/products/brk-010",
   "/?pid=139449367": "/products/squ-k21",
   "/?pid=139457501": "/products/a-k21",
   "/?pid=145401577": "/products/squ-020",
   "/?pid=145400995": "/products/x-020",
   "/?pid=145442539": "/products/i-020",
   "/?pid=147910837": "/products/trp-k21",
   "/?pid=144614763": "/products/i-k21",
   "/?pid=145401571": "/products/r-020",
   "/?pid=145458808": "/products/r-010",
   "/?pid=145618798": "/products/pin-k21-q3",
   "/?pid=145620334": "/products/pin-k21-q4",
   "/?pid=141088779": "/products/pin-k22",
   "/?pid=145458815": "/products/pin-010",
   "/?pid=145458823": "/products/pin-011",
   "/?pid=146135509": "/products/sb-k21",
   "/?pid=145442545": "/products/pin-020",
   "/?pid=145787472": "/products/squ-k22",
   "/?pid=144656560": "/products/tvb-k01",
   "/?pid=144656603": "/products/tvb-k02",
   "/?pid=144618728": "/products/tvb-k04",
   "/?pid=144622670": "/products/tvb-k03",
   "/?pid=147127612": "/products/tvb-k05",
   "/?pid=147127622": "/products/tvb-k06",
   "/?pid=147127632": "/products/tvb-k07",
   "/?pid=144623757": "/products/tvb-k08",
   "/?pid=145618610": "/products/tvb-k09",
   "/?pid=148681551": "/products/slf-k01",
   "/?pid=148705910": "/products/slf-k02",
   "/?pid=148705937": "/products/slf-k04",
   "/?pid=148705958": "/products/slf-k03",
   "/?pid=142286794": "/products/tt-k01",
   "/?pid=142286901": "/products/tt-k04",
   "/?pid=142287027": "/products/tt-k02",
   "/?pid=142287116": "/products/tt-k03-na",
   "/?pid=142285202": "/products/tt-k05",
   "/?pid=142285342": "/products/tt-k06",
   "/?pid=142286701": "/products/tt-k07",
   "/?pid=150770244": "/products/tt-k08",
   "/?pid=148864231": "/products/dch-k01",
   "/?pid=148864299": "/products/dch-k02",
   "/?pid=145442552": "/products/dch-107",
   "/?pid=147503074": "/products/dch-103",
   "/?pid=147503087": "/products/dch-104-wh",
   "/?pid=148263657": "/products/dch-111",
   "/?pid=145983733": "/products/dch-108",
   "/?pid=146037988": "/products/dch-110",
   "/?pid=146971761": "/products/dch-105",
   "/?pid=147394643": "/products/dch-109",
   "/?pid=134280284": "/products/dch-101",
   "/?pid=146002565": "/products/dch-101",
   "/?pid=143046509": "/products/dch-106",
   "/?pid=147543597": "/products/dch-106",
   "/?pid=148263825": "/products/och-103",
   "/?pid=150260186": "/products/och-k04",
   "/?pid=144822531": "/products/och-k01",
   "/?pid=147394644": "/products/och-k01",
   "/?pid=149588893": "/products/och-k03",
   "/?pid=145442562": "/products/och-101",
   "/?pid=146871857": "/products/och-101",
   "/?pid=146001660": "/products/och-k02",
   "/?pid=148653314": "/products/och-k02",
   "/?pid=147292523": "/products/och-102",
   "/?pid=144764768": "/products/bnc-102",
   "/?pid=147996472": "/products/bnc-104",
   "/?pid=147996497": "/products/bnc-105",
   "/?pid=147394648": "/products/bnc-103",
   "/?pid=148376067": "/products/bnc-101-bk",
   "/?pid=148376076": "/products/bnc-101-bk",
   "/?pid=146871955": "/products/stl-105",
   "/?pid=147327168": "/products/stl-101",
   "/?pid=146473450": "/products/stl-103",
   "/?pid=148557004": "/products/stl-106-br",
   "/?pid=148773553": "/products/stl-106-bk",
   "/?pid=145809161": "/products/stl-104",
   "/?pid=145916124": "/products/stl-104",
   "/?pid=148796774": "/products/sf-101-be",
   "/?pid=151384659": "/products/sf-101-bl",
   "/?pid=151384757": "/products/sf-101-gr",
   "/?pid=136277707": "/products/fll-101",
   "/?pid=145906445": "/products/fll-101",
   "/?pid=151297953": "/products/fll-103",
   "/?pid=151465665": "/products/fll-103",
   "/?pid=146300233": "/products/pdl-101",
   "/?pid=151297972": "/products/pdl-115",
   "/?pid=151659734": "/products/pdl-115",
   "/?pid=136277697": "/products/pdl-102",
   "/?pid=141324010": "/products/pdl-111",
   "/?pid=146872331": "/products/pdl-104",
   "/?pid=146872437": "/products/pdl-103",
   "/?pid=149591912": "/products/pdl-114",
   "/?pid=149592222": "/products/pdl-112",
   "/?pid=146872135": "/products/pdl-105",
   "/?pid=146872245": "/products/pdl-106",
   "/?pid=146872158": "/products/pdl-107",
   "/?pid=136277688": "/products/pdl-108",
   "/?pid=146780158": "/products/fll-102",
   "/?pid=136277690": "/products/pdl-108",
   "/?pid=136277692": "/products/pdl-109",
   "/?pid=136277698": "/products/dsl-101",
   "/?pid=136277703": "/products/dsl-104",
   "/?pid=146069893": "/products/dsl-101",
   "/?pid=146264974": "/products/dsl-104",
   "/?pid=136277701": "/products/dsl-102",
   "/?pid=146278889": "/products/dsl-102",
   "/?pid=151297906": "/products/dsl-105",
   "/?pid=151465408": "/products/dsl-105",
   "/?pid=141324396": "/products/dsl-103",
   "/?pid=139385116": "/products/rac-101",
   "/?pid=141505785": "/products/rac-102",
   "/?pid=143121765": "/products/rac-103",
   "/?pid=147543606": "/products/rac-140",
   "/?pid=148339477": "/products/rac-140",
   "/?pid=145167905": "/products/rac-104",
   "/?pid=140149295": "/products/mir-101",
   "/?pid=141045132": "/products/mir-102",
   "/?pid=147327067": "/products/mir-103",
   "/?pid=147327073": "/products/mir-104",
   "/?pid=146473063": "/products/mir-105",
   "/?pid=148447543": "/products/mir-107",
   "/?pid=150700710": "/products/mir-108",
   "/?pid=145484581": "/products/mir-106",
   "/?pid=146906649": "/products/mir-106",
   "/?pid=145167942": "/products/rac-105",
   "/?pid=145167947": "/products/rac-106",
   "/?pid=146758363": "/products/rac-107",
   "/?pid=146758440": "/products/dsp-101",
   "/?pid=146758433": "/products/dsp-102",
   "/?pid=142013542": "/products/sdb-101",
   "/?pid=150547533": "/products/str-101-bk",
   "/?pid=150609069": "/products/str-101-wh",
   "/?pid=147394206": "/products/par-101",
   "/?pid=151091964": "/products/str-104",
   "/?pid=151321833": "/products/str-104",
   "/?pid=146693681": "/products/str-102",
   "/?pid=146693998": "/products/str-103",
   "/?pid=146693443": "/products/str-102",
   "/?pid=144839003": "/products/str-103",
   "/?pid=145484645": "/products/rug-110",
   "/?pid=145505957": "/products/rug-112",
   "/?pid=146472925": "/products/rug-113",
   "/?pid=147365268": "/products/rug-114",
   "/?pid=147365278": "/products/rug-115",
   "/?pid=149903361": "/products/rug-111-s3",
   "/?pid=141403673": "/products/rug-102",
   "/?pid=144841193": "/products/rug-108",
   "/?pid=141397930": "/products/rug-100",
   "/?pid=141407280": "/products/rug-101",
   "/?pid=141530213": "/products/rug-103",
   "/?pid=141540990": "/products/rug-105",
   "/?pid=142207232": "/products/cur-105-bg",
   "/?pid=142209116": "/products/cur-105-gr",
   "/?pid=141770646": "/products/cur-101-iv",
   "/?pid=144880143": "/products/cur-101-bg",
   "/?pid=141970335": "/products/cur-101-sb",
   "/?pid=144881645": "/products/cur-101-nb",
   "/?pid=142211313": "/products/cur-108",
   "/?pid=141971272": "/products/cur-104",
   "/?pid=141968446": "/products/cur-102-bg",
   "/?pid=142210838": "/products/cur-102-bl",
   "/?pid=142198205": "/products/cur-109-wh",
   "/?pid=142203834": "/products/cur-109-bg",
   "/?pid=142204116": "/products/cur-111-wh",
   "/?pid=142206758": "/products/cur-111-bg",
   "/?pid=142207012": "/products/cur-111-gr",
   "/?pid=141973171": "/products/cur-114-q2",
   "/?pid=148288697": "/products/cur-115-q2",
   "/?pid=144881890": "/products/cur-120-q2",
   "/?pid=144881706": "/products/cur-119-q2",
   "/?pid=145864696": "/products/art-107",
   "/?pid=145864703": "/products/art-108",
   "/?pid=145864711": "/products/art-109",
   "/?pid=145864716": "/products/art-110",
   "/?pid=143411231": "/products/art-105",
   "/?pid=143411052": "/products/art-104",
   "/?pid=143411405": "/products/art-106",
   "/?pid=142519673": "/products/art-100",
   "/?pid=143410975": "/products/art-102",
   "/?pid=143410862": "/products/art-101",
   "/?pid=140227454": "/products/tbl-g01",
   "/?pid=144613703": "/products/tbl-g01",
   "/?pid=147911417": "/products/tbl-g01",
   "/?pid=141088144": "/products/tbl-g01",
   "/?pid=141496312": "/products/tbl-g01",
   "/?pid=146532652": "/products/tbl-g01",
   "/?pid=145097777": "/products/tbl-g02",
   "/?pid=145170508": "/products/tbl-g02",
   "/?pid=146532935": "/products/tbl-g02",
   "/?pid=147911419": "/products/tbl-g02",
   "/?pid=143932737": "/products/tbl-g05",
   "/?pid=146739232": "/products/tbl-g05",
   "/?pid=147450979": "/products/chr-601",
   "/?pid=147450982": "/products/chr-601",
   "/?pid=141086197": "/products/chr-602",
   "/?pid=141504497": "/products/chr-602",
   "/?pid=144095930": "/products/tbl-g03",
   "/?pid=144764800": "/products/chr-603",
   "/?pid=144808310": "/products/chr-603",
   "/?pid=144048368": "/products/tbl-g03",
   "/?pid=147214503": "/products/tbl-g04",
   "/?pid=147214534": "/products/tbl-g04",
   "/?pid=143050909": "/products/chr-604",
   "/?pid=143112411": "/products/chr-604",
   "/?pid=147543617": "/products/sdt-270",
   "/?pid=147856520": "/products/sdt-270",
   "/?pid=149589298": "/products/pdl-604",
   "/?pid=150289716": "/products/pdl-604",
   "/?pid=147543612": "/products/sdt-210",
   "/?pid=148813800": "/products/sdt-210",
   "/?pid=149592103": "/products/pdl-605",
   "/?pid=149592214": "/products/pdl-606",
   "/?pid=151297924": "/products/fll-604",
   "/?pid=151465562": "/products/fll-604",
   "/?pid=141324457": "/products/pdl-603",
   "/?pid=141324854": "/products/pdl-601",
   "/?pid=136277706": "/products/fll-603",
   "/?pid=144734425": "/products/fll-601",
   "/?pid=144746776": "/products/fll-602",
   "/?pid=144746905": "/products/pdl-602",
   "/?pid=141324370": "/products/dsl-601",
   "/?pid=151297856": "/products/dsl-602",
   "/?pid=147895661": "/products/pot-k01-bk",
   "/?pid=148032620": "/products/pot-k01-gr",
   "/?pid=148032626": "/products/pot-k01-pk",
   "/?pid=148032630": "/products/pot-k01-wh",
   "/?pid=148032639": "/products/pot-k01-gn",
   "/?pid=148376215": "/products/pot-101",
   "/?pid=148376240": "/products/pot-102",
   "/?pid=148376276": "/products/pot-103",
   "/?pid=148376321": "/products/pot-104",
   "/?pid=148376341": "/products/pot-105",
   "/?pid=150700812": "/products/pot-106",
   "/?pid=150700895": "/products/pot-107",
   "/?pid=148652716": "/products/btt-102",
   "/?pid=151465992": "/products/btt-102",
   "/?pid=148376370": "/products/btt-103",
   "/?pid=147932469": "/products/slc-105",
   "/?pid=147932484": "/products/slc-106",
   "/?pid=147451040": "/products/slc-108",
   "/?pid=146568301": "/products/slc-101",
   "/?pid=146881019": "/products/slc-102",
   "/?pid=147935065": "/products/slc-104",
   "/?pid=147935073": "/products/slc-103",
   "/?pid=147438829": "/products/slc-107"
}